import { makeStyles } from '@material-ui/core/styles';
import crewUserStyles from '../components/CrewBlock/components/CrewUser/styles';

export default makeStyles(crewUserStyles);
